import React, { useEffect, useState } from "react";
import "./customAnimatedCards.css";

const CustomAnimatedCards = ({ cards, cardWidth = "auto", cardHeight = "auto" }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) return;

    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % cards.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [cards.length, isMobile]);

  return (
    <div
      className={`custom-animated-card ${isMobile ? "custom-mobile-grid" : ""}`}
    >
      {cards?.map((card, index) => (
        <div
          key={index}
        
          className={`custom-animated-card-content ${
            !isMobile && activeIndex === index ? "custom-active" : ""
          }`}
        >
          <div>
            <img
              src={
                !isMobile && activeIndex === index
                  ? card?.activeImage
                  : card?.inactiveImage
              }
              alt=""
            />
          </div>
          <div className="custom-card-animated-text">
            <div className="custom-card-anim-text">{card?.title}</div>
            {!isMobile && activeIndex === index && (
              <div className="custom-card-animated-content">
                {card?.content}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CustomAnimatedCards;
